module.exports = __webpack_public_path__ + "static/SubmitWithdraw-3ed24030de60e46fdbcf1bf78e38785c.png";